import { create } from 'zustand';
import ShortUniqueId from 'short-unique-id';

export interface INotification {
  id: string;
  text: string;
}

interface INotificationsStore {
  notifications: INotification[];
  addNotification: (notification: Omit<INotification, 'id'>) => void;
  removeNotification: (id: string) => void;
}

const uid = new ShortUniqueId({ length: 10 });

export const useNotificationsStore = create<INotificationsStore>(
  (set, get) => ({
    notifications: [],
    removeNotification: id =>
      set(state => ({
        notifications: state.notifications.filter(
          notification => notification.id !== id,
        ),
      })),
    addNotification: notification => {
      const extendedNotification = { ...notification, id: uid() };

      setTimeout(() => {
        get().removeNotification(extendedNotification.id);
      }, 5000);

      set(state => ({
        notifications: [extendedNotification, ...state.notifications],
      }));
    },
  }),
);
